import { useSearchParams } from "react-router-dom";
import { Box } from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY, PAGE_CONTENT_MAX_WIDTH } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";
import { usePrefetchMasonryNode } from "hooks/use-prefetch-masonry-node.hook";

export const SelfCollectionAddressConfirmationPage = () => {
  const [searchParams] = useSearchParams();
  const programId = searchParams.get("programId") ?? "";

  usePrefetchMasonryNode(MASONRY.ROOT_NODE_ID_SELF_COLLECTION_ORDER_PLACED);

  usePageViewAnalytics({ screen_name: "Self Collection Address Confirmation" });
  const { formatMessage } = useIntl();

  const title = formatMessage({
    id: "STR_SELF_COLLECTION_ADDRESS_CONFIRMATION",
  });
  useDocumentTitle(title);

  return (
    <PageContentWrapper>
      <PageHeader variant="sub-page" mobileBand="green" headingText={title} />
      <Box css={{ maxWidth: PAGE_CONTENT_MAX_WIDTH, marginInline: "auto" }}>
        <Masonry
          rootNodeId={MASONRY.ROOT_NODE_ID_SELF_COLLECTION_ADDRESS_CONFIRMATION}
          initialQueryParams={{ programId }}
        />
      </Box>
    </PageContentWrapper>
  );
};
